import {JetView} from "webix-jet";

/**
 * AgeView class extends JetView to create a chart displaying user balances by age.
 */
export default class AgeView extends JetView {
	/**
	 * Configures the view layout and components.
	 * @returns {Object} The configuration object for the view.
	 */
	config(){
		const _ = this.app.getService("locale")._; // Localization service for text translation
		return {
			type:"clean", // Clean layout type
			rows:[
				{ 
					template:_("Saldo Actual de usuarios por Edades"), // Header template with localized text
					type:"header", 
					css:"webix_header chart_header" // CSS class for styling the header
				},
				{
					view:"chart", // Chart component
					type:"scatter", // Scatter chart type
					localId:"chart", // Local ID for referencing the chart
					padding:{
						top:10, // Padding for the top
						left:50, // Padding for the left
						bottom:40 // Padding for the bottom
					},
					/**
					 * Function to calculate the x-axis value based on the user's age.
					 * @param {Object} obj - The data object containing user information.
					 * @returns {number} The calculated age value for the x-axis.
					 */
					xValue:obj => {
						return (new Date().getFullYear() - new Date(obj.age).getFullYear()); // Age calculation
					},
					value:"#money#", // Data field for the y-axis value
					item:{
						borderColor:"#fff", // Border color for chart items
						color:"#8664C6", // Fill color for chart items
						shadow:false, // Shadow effect for items
						radius:7, // Radius of chart items
						type:"d" // Type of chart item
					},
					xAxis:{
						start:22, // Starting value for the x-axis
						step:4, // Step size for the x-axis
						lines:false, // Disable grid lines
						color:"#EDEFF0", // Color of the x-axis
						title:_("Edad") // Title for the x-axis with localization
					},
					yAxis:{
						start:0, // Starting value for the y-axis
						step:500, // Step size for the y-axis
						color:"#fff", // Color of the y-axis
						lineColor:"#EDEFF0", // Line color for the y-axis
						title:_("Saldo") // Title for the y-axis with localization
					},
					tooltip:{
						template:"<b>#user#</b><br>$#money#" // Tooltip template for displaying user and money
					}
				}
			]
		};
	}

	/**
	 * Initializes the view and sets up event listeners.
	 */
	init(){
		const cur_user = this.getParam("user", true); // Retrieve the current user parameter
		var vthis = this; // Preserve the context of 'this'
		this.on(this.app, "statisticsAgent:ageUsersStat", data => {
			vthis.$$("chart").clearAll(); // Clear existing chart data
			vthis.$$("chart").parse(data); // Parse new data into the chart
		});	
	}
}

// FILE DOCUMENTED
